import s from "./ToolPage.module.scss";
import { Page } from "../../layout/Layout";
import { SectionPromo } from "../../shared/sections/SectionPromo";
import { ToolSections } from "./sections/ToolSections";
import { Container } from "../../layout/Container";
import { CurrentTool } from "./CurrentTool";
import { useToolSinglePageContext } from "@/helpers/contexts/ToolSinglePageContext";
import "@/styles/critical/_section-promo.scss";
import { PageGradientWrapper } from "@/components/layout/PageGradientWrapper";
import dynamic from "next/dynamic";

const DynamicTool = dynamic(() => import("../../../lib/dynamicTool"), { ssr: false });

const ToolPage = () => {
  const data = useToolSinglePageContext();
  if (!data) return null;
  const { tool, isPreview, breadcrumbsList } = data;

  const { heading, meta, subheading, image, sections, tool: toolId, toolSlug } = tool;

  return (
    <Page {...meta} isPreview={isPreview}>
      <PageGradientWrapper>
        <SectionPromo
          heading={heading}
          subheading={subheading}
          breadcrumbs={breadcrumbsList}
          titleLevel={2}
          background="transparent"
          type="cols"
          image={{
            src: image.url,
            width: 400,
            height: 400,
          }}
        />

        <Container className={s.tool}>
          {toolSlug ? <DynamicTool slug={toolSlug} /> : toolId && <CurrentTool tool={toolId} />}
        </Container>
        {sections && <ToolSections sections={sections} />}
      </PageGradientWrapper>
    </Page>
  );
};

export default ToolPage;
